import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  locationKey: '',
  floorKey: '',
  sectionKey: '',
  section: '',
  floor: '',
};

export const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setLocationKey: (state, action) => {
      state.locationKey = action.payload;
    },
    setFloorKey: (state, action) => {
      state.floorKey = action.payload;
    },
    setSectionKey: (state, action) => {
      state.sectionKey = action.payload;
    },
    setFloor: (state, action) => {
      state.floor = action.payload;
    },
    setSection: (state, action) => {
      state.section = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setLocationKey,
  setFloorKey,
  setSectionKey,
  setFloor,
  setSection,
} = locationSlice.actions;
